import $ from 'jquery';
import _ from 'underscore';

/**
 * Creates a function that wraps the callback and only calls it if target is inside the document
 *
 * @param {Function} callback
 * @param {DOMElement} target
 * @return {Function}
 */
function callIfTargetInDom(callback, target) {
    return (...args) => {
        if (!$.contains(document, target)) return false;
        return callback(...args);
    };
}

/**
 * Debounce a callback separately for every event target
 *
 * @param {Map} map Map of every debounced callback
 * @param {Function} callback Function to debounce
 * @param {number} delay Time to debounce in ms
 * @return {Function}
 */
function createDebouncedCallback(map, callback, delay) {
    return function debounceSelectorCallback(event, ...eventArgs) {
        if (!map.has(event.currentTarget)) {
            map.set(
                event.currentTarget,
                _.debounce(callIfTargetInDom(callback.bind(this), event.currentTarget), delay),
            );
        }

        const debouncedCallback = map.get(event.currentTarget);

        return debouncedCallback(event, ...eventArgs);
    };
}

/**
 * Add event listener with a delay and debounce the calls
 *
 * @param {...*} onArguments The same arguments as jQuerys on() method
 * @return {*}
 */
export default $.fn.delayedOn = function delayedOn(...onArguments) {
    const delay = onArguments.pop();
    const callbackMap = new Map();

    const debouncedArgs = onArguments.map((argument) => {
        if (typeof argument !== 'function') return argument;

        return createDebouncedCallback(callbackMap, argument, delay);
    });

    return $(this).on(...debouncedArgs);
};
